import React from "react";
import { resolveCmsAsset } from "../../cms/media";

export default function TextImageBlock({ id, type, title, text, items = [], image, imageAlt, layout = "right" }) {
  const copy = (
    <div className="col-12 col-lg-6">
      {title && <h2 className="section-heading mb-4">{title}</h2>}
      {text && <p>{text}</p>}
      {items.length > 0 && (
        <ul>
          {items.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      )}
    </div>
  );

  const visual = image ? (
    <div className="col-12 col-lg-6">
      <picture>
        <img
          className="img-fluid rounded shadow-sm"
          src={resolveCmsAsset(image)}
          alt={imageAlt || title || ""}
        />
      </picture>
    </div>
  ) : null;

  return (
    <div className="container">
      <div className="py-6 row gx-8 align-items-center">
        {layout === "left" ? (
          <>{visual}{copy}</>
        ) : (
          <>{copy}{visual}</>
        )}
      </div>
    </div>
  );
}
